import { combineReducers} from 'redux';
import user from './user';
import contract from './contract';
import token from './token';
import tmpUpload from './tmpUpload';
import admin from './admin'

export default combineReducers({ user, contract, token, tmpUpload, admin })